import { useState,useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
// components
import Iconify from '../../../components/iconify';

import { GlobalContext } from '../../../components/globalContext/GlobalContext';
import Dialog from '../../../components/dialog/Dialog';
import { apiUrl } from '../../../components/apiUrl/ApiUrl';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState('FM');
  const [globalVar, setGlobalVar] = useContext(GlobalContext);

  console.log(`${apiUrl}/Login/CheckAuth`)
  const handleClick = async () => {
  try {
    const response = await axios.post(
      `${apiUrl}/Login/CheckAuth`,
      {
        username,
        password,
        company,
      },
      {
        headers: {
          'X-Company': company,
        },
      }
    );

    if (response.status !== 200) {
      throw new Error('登入失敗');
    }

    const tokenResponse = response.data.tokenRespense;

    const base64Url = tokenResponse.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonData = JSON.parse(
      decodeURIComponent(escape(window.atob(base64)))
    );

    const roleFromApi = response.data.role ?? response.data.Role;
    const roleFromJwt = jsonData.role;
    const userSN = roleFromApi ?? roleFromJwt ?? '';

    if (!tokenResponse || !userSN || userSN.trim() === '') {
      throw new Error('Login failed');
    }

    const loginCompany = response.data.company ?? company;

    setGlobalVar(jsonData.name);

    sessionStorage.setItem('token', tokenResponse);
    sessionStorage.setItem('jwtData', JSON.stringify(jsonData));
    sessionStorage.setItem('userName', jsonData.name);
    sessionStorage.setItem('Id', response.data.id);
    sessionStorage.setItem('Can', response.data.canCRUDuser);
    sessionStorage.setItem('userSN', userSN);
    sessionStorage.setItem('company', loginCompany);

    setOpen(true);
    setIsLogin(true);
  } catch (error) {
    sessionStorage.clear();

    setOpen(true);
    setIsLogin(false);
    setGlobalVar('帳號密碼錯誤');
  }
};

  const nav = () => {
    navigate('/dashboard/products', { replace: true });  // Navigate after closing the dialog
  };

  return (
    <>
      <Stack spacing={3}>
       
        <FormControl fullWidth>
          <InputLabel id="company-select-label">公司別</InputLabel>
          <Select
            labelId="company-select-label"
            id="company-select"
            data-testid="login-company"
            value={company}
            label="公司別"
            onChange={(e) => {
              setCompany(e.target.value);
              sessionStorage.clear();
              setGlobalVar('');
            }}
          >
            <MenuItem value="FM">FM</MenuItem>
            <MenuItem value="HC">HC</MenuItem>
          </Select>
        </FormControl>
        {process.env.NODE_ENV !== 'production' && (
          <select
            aria-hidden="true"
            data-testid="login-company-test-control"
            value={company}
            onChange={(e) => {
              setCompany(e.target.value);
              sessionStorage.clear();
              setGlobalVar('');
            }}
            style={{
              height: 1,
              left: -10000,
              opacity: 0,
              position: 'absolute',
              top: 'auto',
              width: 1,
            }}
            tabIndex={-1}
          >
            <option value="FM">FM</option>
            <option value="HC">HC</option>
          </select>
        )}
        
        <TextField 
          name="account" 
          label="User Account" 
          inputProps={{ 'data-testid': 'login-account' }}
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          inputProps={{ 'data-testid': 'login-password' }}
          value={password}
          onChange={e => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {/* <Checkbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link> */}
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick} data-testid="login-submit">
        Login
      </LoadingButton> 
      <Dialog open={open} setOpen={setOpen} isLogin={isLogin} nav={nav} user={globalVar}/>
    </>
  );
}
